let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9zjWJ")).then(() => parcelRequire('g2CU3'));